'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import { connect } from 'react-redux';
import { parse } from 'hub-http/helpers/params';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIHeader from 'UIComponents/layout/UIHeader';
import UIListingPage from 'UIComponents/page/UIListingPage';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { getPortalHasMarketableContacts, hasWriteScope, hasAdsTrustedScope } from 'AdsUI/selectors/AuthSelectors';
import useSavePortalSignup from 'AdsUI/lib/useSavePortalSignup';
import CreateAdAccountLink from 'AdsUI/components/onboarding/CreateAdAccountLink';
import CouponBannerWrapper from 'AdsUI/components/onboarding/CouponBannerWrapper';
import EmptyStateActionButtons from './EmptyStateActionButtons';
import AdsAcademyVideoCTA from '../AdsAcademyVideoCTA';
import { useEffect, useState } from 'react';
import { getHubs2Info } from 'AdsUI/data/HubAttributesData';
import { HUB_TYPES } from 'AdsUI/lib/Constants';
import Raven from 'raven-js';
const GOOGLE_COUPON_LEARN_MORE = 'https://www.hubspot.com/products/marketing/google-ads#Promocode';
const LINKEDIN_COUPON_LEARN_MORE = 'https://www.hubspot.com/linkedin-ads#TermsCondition';

const EmptyState = ({
  dispatch,
  hasAdsWrite,
  hasAdsTrusted,
  location,
  hasMarketingContacts
}) => {
  const query = parse(location.search.substring(1));
  useSavePortalSignup(dispatch, query);
  const [loading, setLoading] = useState(true);
  const [isDeveloperPortal, setIsDeveloperPortal] = useState(true);
  useEffect(() => {
    setLoading(true);
    getHubs2Info().then(response => {
      setIsDeveloperPortal(response.hubType === HUB_TYPES.DEVELOPER_TEST);
      setLoading(false);
    }).catch(error => {
      Raven.captureMessage('Fetch to hubs2 for hubtype failed', {
        extra: error
      });
    });
  }, []);
  return !loading && /*#__PURE__*/_jsxs(UIListingPage, {
    headerComponent: /*#__PURE__*/_jsx(UIHeader, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ads"
      })
    }),
    children: [/*#__PURE__*/_jsx(CouponBannerWrapper, {}), /*#__PURE__*/_jsx(UIEmptyState, {
      titleText: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "zeroState.title"
        })
      }),
      primaryContent: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "zeroState.summary"
          })
        }), /*#__PURE__*/_jsxs(UIList, {
          childClassName: "dashed-list-style-type m-bottom-2",
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "zeroState.revenue"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "zeroState.adInteraction"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: hasMarketingContacts ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "zeroState.reengageMarketingContacts"
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "zeroState.reengage"
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "zeroState.alignment"
            })
          })]
        }), !isDeveloperPortal && /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "zeroState.coupon_jsx",
          options: {
            linkedInOffer: LINKEDIN_COUPON_LEARN_MORE,
            GoogleOffer: GOOGLE_COUPON_LEARN_MORE
          },
          elements: {
            Link: UILink
          }
        }), /*#__PURE__*/_jsx(EmptyStateActionButtons, {
          className: "m-top-5",
          hasAdsWrite: hasAdsWrite
        }), hasAdsTrusted && hasAdsWrite && /*#__PURE__*/_jsx("div", {
          className: "m-top-4 text-left",
          children: /*#__PURE__*/_jsx(CreateAdAccountLink, {
            isDeveloperPortal: isDeveloperPortal
          })
        }), /*#__PURE__*/_jsx(AdsAcademyVideoCTA, {
          option: "accounts",
          showDetails: true
        }), /*#__PURE__*/_jsx(NavMarker, {
          name: "EMPTY_STATE_LOADED"
        })]
      }),
      secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
        name: "add-on-ads",
        width: "100%"
      }),
      secondaryContentWidth: 300,
      maxWidth: 935
    })]
  });
};

export default connect(state => ({
  hasAdsWrite: hasWriteScope(state),
  hasAdsTrusted: hasAdsTrustedScope(state),
  hasMarketingContacts: getPortalHasMarketableContacts(state)
}))(EmptyState);